<template>
    <div id="popup-container" v-if="!loading">
        <v-toolbar dark color="primary">
            <v-toolbar-title class="heading-title">
                Test Results
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn fab x-small class="close" @click="closePanel">
                <v-icon dark color="white">fa-times</v-icon>
            </v-btn>
        </v-toolbar>
        <v-stepper v-model="e1" :steps="questions" ref="myStepper">
            <v-stepper-header>
                <template v-for="(n, index) in questions">
                    <v-stepper-step :key="`${n.id}-step`" :complete="e1 > index" :step="index + 1"  v-if="questions.length>1" 
                        color="primary"></v-stepper-step>

                    <v-divider v-if="n !== questions" :key="n.id"></v-divider>
                </template>
            </v-stepper-header>
            <v-stepper-items>
                <v-stepper-content v-for="(question, index) in questions" :key="`${question.id}-content`" :step="index + 1">
                    <h4>{{ question.question }}</h4>
                    <v-container v-if="question.question_type == 1">
                        <v-radio-group v-model="answers[question.id]" :mandatory="false" class="pa-10" :key="index">
                            <v-flex :class="QuestionClass">
                                <v-radio v-if="question.a !== null && question.a !== ''" :label="question.a" value="a" disabled></v-radio>
                                <!-- <v-icon v-if="question.a !== null && question.a !== '' && question.correct_answer === 'a'"
                                color="green">fa fa-check</v-icon> -->
                                <v-icon
                                v-if="question.a !== null && question.a !== '' && question.correct_answer === 'a' && answers[question.id] === 'a'"
                                color="green">fa fa-check</v-icon>
                                <v-icon
                                v-else-if="question.a !== null && question.a !== '' && question.correct_answer != 'a' && answers[question.id] === 'a'"
                                color="red">fa fa-times</v-icon>
                            </v-flex>
                            <v-flex :class="QuestionClass">
                                <v-radio v-if="question.b !== null && question.b !== ''" :label="question.b" value="b"
                                    disabled></v-radio>
                                <!-- <v-icon
                                v-if="question.b !== null && question.b !== '' && question.correct_answer === 'b'" color="green">fa
                                fa-check</v-icon> -->
                                <v-icon
                                v-if="question.b !== null && question.b !== '' && question.correct_answer === 'b' && answers[question.id] === 'b'"
                                color="green">fa fa-check</v-icon>
                                <v-icon
                                v-else-if="question.b !== null && question.b !== '' && question.correct_answer != 'b' && answers[question.id] === 'b'"
                                color="red">fa fa-times</v-icon>
                            </v-flex>
                            <v-flex :class="QuestionClass">
                                <v-radio v-if="question.c !== null && question.c !== ''" :label="question.c" value="c"
                                disabled></v-radio>
                                <!-- <v-icon
                                v-if="question.c !== null && question.c !== '' && question.correct_answer === 'c'" color="green">fa
                                fa-check</v-icon> -->
                                <v-icon
                                v-if="question.c !== null && question.c !== '' && question.correct_answer === 'c' && answers[question.id] === 'c'"
                                color="green">fa fa-check</v-icon>
                                <v-icon
                                v-else-if="question.c !== null && question.c !== '' && question.correct_answer != 'c' && answers[question.id] === 'c'"
                                color="red">fa fa-times</v-icon>
                            </v-flex>
                            <v-flex :class="QuestionClass">
                                <v-radio v-if="question.d !== null && question.d !== ''" :label="question.d" value="d"
                                disabled></v-radio>
                                <!-- <v-icon
                                v-if="question.d !== null && question.d !== '' && question.correct_answer === 'd'" color="green">fa
                                fa-check</v-icon> -->
                                <v-icon
                                v-if="question.d !== null && question.d !== '' && question.correct_answer === 'd' && answers[question.id] === 'd'"
                                color="green">fa fa-check</v-icon>
                                <v-icon
                                v-else-if="question.d !== null && question.d !== '' && question.correct_answer != 'd' && answers[question.id] === 'd'"
                                color="red">fa fa-times</v-icon>
                            </v-flex>
                        </v-radio-group>
                    </v-container>
                    <v-container v-if="question.question_type == 2">
                        <v-flex :class="QuestionClass">
                            <v-text-field disabled v-if="question.a !== null && question.a !== ''"
                                v-model="answers[question.id]" label="Your Answer" type="text" filled>
                            </v-text-field>
                            <v-icon class="check-icon mt-1"
                            v-if="question.a !== null && question.a !== '' && question.a === answers[question.id]" color="green">fa
                            fa-check</v-icon>
                        <v-icon class="times-icon mt-1" v-else color="red">fa fa-times</v-icon>
                        </v-flex>
                        <!-- <v-text-field disabled v-if="question.a !== null && question.a !== '' && question.a != answers[question.id]"
                        v-model="question.a" label="Correct Answer" type="text" filled>
                        </v-text-field> -->
                    </v-container>
                    <v-container fluid v-if="question.question_type == 3">
                        <v-flex :class="QuestionClass">
                        <v-checkbox v-if="question.a !== null && question.a !== ''" :label="question.a" value="a" disabled
                            v-model="multi_answers[question.id]"></v-checkbox>
                        <!-- <v-icon class="check-icon mt-1"
                            v-if="question.a !== null && question.a !== '' && question.correct_answer.includes('a')" color="green">fa
                            fa-check</v-icon> -->
                        <v-icon class="check-icon mt-1"
                            v-if="question.a !== null && question.a !== '' && question.correct_answer.includes('a') && multi_answers[question.id].includes('a')"
                            color="green">fa fa-check</v-icon>
                        <v-icon class="times-icon mt-1"
                            v-else-if="question.a !== null && question.a !== '' && !question.correct_answer.includes('a') && multi_answers[question.id].includes('a')"
                            color="red">fa fa-times</v-icon>
                        </v-flex>
                        <v-flex :class="QuestionClass">
                        <v-checkbox v-if="question.b !== null && question.b !== ''" :label="question.b" value="b" disabled
                            v-model="multi_answers[question.id]"></v-checkbox>
                        <!-- <v-icon class="check-icon mt-1"
                            v-if="question.b !== null && question.b !== '' && question.correct_answer.includes('b')" color="green">fa
                            fa-check</v-icon> -->
                        <v-icon class="check-icon mt-1"
                            v-if="question.b !== null && question.b !== '' && question.correct_answer.includes('b') && multi_answers[question.id].includes('b')"
                            color="green">fa fa-check</v-icon>
                        <v-icon class="times-icon mt-1"
                            v-else-if="question.b !== null && question.b !== '' && !question.correct_answer.includes('b') && multi_answers[question.id].includes('b')"
                            color="red">fa fa-times</v-icon>
                        </v-flex>
                        <v-flex :class="QuestionClass">
                        <v-checkbox v-if="question.c !== null && question.c !== ''" :label="question.c" value="c" disabled
                            v-model="multi_answers[question.id]"></v-checkbox>
                        <!-- <v-icon class="check-icon mt-1"
                            v-if="question.c !== null && question.c !== '' && question.correct_answer.includes('c')" color="green">fa
                            fa-check</v-icon> -->
                        <v-icon class="check-icon mt-1"
                            v-if="question.c !== null && question.c !== '' && question.correct_answer.includes('c') && multi_answers[question.id].includes('c')"
                            color="green">fa fa-check</v-icon>
                        <v-icon class="times-icon mt-1"
                            v-else-if="question.c !== null && question.c !== '' && !question.correct_answer.includes('c') && multi_answers[question.id].includes('c')"
                            color="red">fa fa-times</v-icon>
                        </v-flex>
                        <v-flex :class="QuestionClass">
                        <v-checkbox v-if="question.d !== null && question.d !== ''" :label="question.d" value="d" disabled
                            v-model="multi_answers[question.id]"></v-checkbox>
                        <!-- <v-icon class="check-icon mt-1"
                            v-if="question.d !== null && question.d !== '' && question.correct_answer.includes('d')" color="green">fa
                            fa-check</v-icon> -->
                        <v-icon class="check-icon mt-1"
                            v-if="question.d !== null && question.d !== '' && question.correct_answer.includes('d') && multi_answers[question.id].includes('d')"
                            color="green">fa fa-check</v-icon>
                        <v-icon class="times-icon mt-1"
                            v-else-if="question.d !== null && question.d !== '' && !question.correct_answer.includes('d') && multi_answers[question.id].includes('d')"
                            color="red">fa fa-times</v-icon>
                        </v-flex>
                        <v-flex :class="QuestionClass">
                        <v-checkbox v-if="question.e !== null && question.e !== ''" :label="question.e" value="e" disabled
                            v-model="multi_answers[question.id]"></v-checkbox>
                        <!-- <v-icon class="check-icon mt-1"
                            v-if="question.e !== null && question.e !== '' && question.correct_answer.includes('e')" color="green">fa
                            fa-check</v-icon> -->
                        <v-icon class="check-icon mt-1"
                            v-if="question.e !== null && question.e !== '' && question.correct_answer.includes('e') && multi_answers[question.id].includes('e')"
                            color="green">fa fa-check</v-icon>
                        <v-icon class="times-icon mt-1"
                            v-else-if="question.e !== null && question.e !== '' && !question.correct_answer.includes('e') && multi_answers[question.id].includes('e')"
                            color="red">fa fa-times</v-icon>
                        </v-flex>
                        <v-flex :class="QuestionClass">
                        <v-checkbox v-if="question.f !== null && question.f !== ''" :label="question.f" value="f" disabled
                            v-model="multi_answers[question.id]"></v-checkbox>
                        <!-- <v-icon class="check-icon mt-1"
                            v-if="question.f !== null && question.f !== '' && question.correct_answer.includes('f')" color="green">fa
                            fa-check</v-icon> -->
                        <v-icon class="check-icon mt-1"
                            v-if="question.f !== null && question.f !== '' && question.correct_answer.includes('f') && multi_answers[question.id].includes('f')"
                            color="green">fa fa-check</v-icon>
                        <v-icon class="times-icon mt-1"
                            v-else-if="question.f !== null && question.f !== '' && !question.correct_answer.includes('f') && multi_answers[question.id].includes('f')"
                            color="red">fa fa-times</v-icon>
                        </v-flex>
                        <v-flex :class="QuestionClass">
                        <v-checkbox v-if="question.g !== null && question.g !== ''" :label="question.g" value="g" disabled
                            v-model="multi_answers[question.id]"></v-checkbox>
                        <!-- <v-icon class="check-icon mt-1"
                            v-if="question.g !== null && question.g !== '' && question.correct_answer.includes('g')" color="green">fa
                            fa-check</v-icon> -->
                        <v-icon class="check-icon mt-1"
                            v-if="question.g !== null && question.g !== '' && question.correct_answer.includes('g') && multi_answers[question.id].includes('g')"
                            color="green">fa fa-check</v-icon>
                        <v-icon class="times-icon mt-1"
                            v-else-if="question.g !== null && question.g !== '' && !question.correct_answer.includes('g') && multi_answers[question.id].includes('g')"
                            color="red">fa fa-times</v-icon>
                        </v-flex>
                        <v-flex :class="QuestionClass">
                        <v-checkbox v-if="question.h !== null && question.h !== ''" :label="question.h" value="h" disabled
                            v-model="multi_answers[question.id]"></v-checkbox>
                        <!-- <v-icon class="check-icon mt-1"
                            v-if="question.h !== null && question.h !== '' && question.correct_answer.includes('h')" color="green">fa
                            fa-check</v-icon> -->
                        <v-icon class="check-icon mt-1"
                            v-if="question.h !== null && question.h !== '' && question.correct_answer.includes('h') && multi_answers[question.id].includes('h')"
                            color="green">fa fa-check</v-icon>
                        <v-icon class="times-icon mt-1"
                            v-else-if="question.h !== null && question.h !== '' && !question.correct_answer.includes('h') && multi_answers[question.id].includes('h')"
                            color="red">fa fa-times</v-icon>
                        </v-flex>
                        <v-flex :class="QuestionClass">
                        <v-checkbox v-if="question.i !== null && question.i !== ''" :label="question.i" value="i" disabled
                            v-model="multi_answers[question.id]"></v-checkbox>
                        <!-- <v-icon class="check-icon mt-1"
                            v-if="question.i !== null && question.i !== '' && question.correct_answer.includes('i')" color="green">fa
                            fa-check</v-icon> -->
                        <v-icon class="check-icon mt-1"
                            v-if="question.i !== null && question.i !== '' && question.correct_answer.includes('i') && multi_answers[question.id].includes('i')"
                            color="green">fa fa-check</v-icon>
                        <v-icon class="times-icon mt-1"
                            v-else-if="question.i !== null && question.i !== '' && !question.correct_answer.includes('i') && multi_answers[question.id].includes('i')"
                            color="red">fa fa-times</v-icon>
                        </v-flex>
                        <v-flex :class="QuestionClass">
                        <v-checkbox v-if="question.j !== null && question.j !== ''" :label="question.j" value="j" disabled
                            v-model="multi_answers[question.id]"></v-checkbox>
                        <!-- <v-icon class="check-icon mt-1"
                            v-if="question.j !== null && question.j !== '' && question.correct_answer.includes('j')" color="green">fa
                            fa-check</v-icon> -->
                        <v-icon class="check-icon mt-1"
                            v-if="question.j !== null && question.j !== '' && question.correct_answer.includes('j') && multi_answers[question.id].includes('j')"
                            color="green">fa fa-check</v-icon>
                        <v-icon class="times-icon mt-1"
                            v-else-if="question.j !== null && question.j !== '' && !question.correct_answer.includes('j') && multi_answers[question.id].includes('j')"
                            color="red">fa fa-times</v-icon>
                        </v-flex>
                    </v-container>
                    <v-container v-if="question.question_type == 4">
                        <div v-if="question.a !== ''">{{ question.a }}
                        <v-select item-disabled="disable"
                            :items="multipleChoiceOptions.filter((e) => { return e.qid == question.id; })"
                            v-model="associate_answer1[question.id]" item-value="id" item-text="name" label="Associate Option" filled>
                            <template v-slot:item="{ active, item, attrs, on }">
                            <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                                <v-list-item-content>
                                <v-list-item-title>
                                    <v-row no-gutters align="center">
                                    <span>{{ item.name }}</span>
                                    <!-- <v-icon class="check-icon" v-if="question.a !== null && question.a !== '' && item.value === 'f'"
                                        color="green">fa
                                        fa-check
                                    </v-icon> -->
                                    <v-icon class="check-icon"
                                        v-if="question.a !== null && question.a !== '' && item.value === 'f' && associate_answer1[question.id] === item.name"
                                        color="green">fa fa-check</v-icon>
                                    <v-icon class="times-icon"
                                        v-else-if="question.a !== null && question.a !== '' && item.value != 'f' && associate_answer1[question.id] === item.name"
                                        color="red">fa fa-times</v-icon>
                                    </v-row>
                                </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            </template>
                        </v-select>
                        </div>
                        <div v-if="question.b !== ''"><v-select item-disabled="disable"
                            :items="multipleChoiceOptions.filter((e) => { return e.qid == question.id; })"
                            v-model="associate_answer2[question.id]" item-value="id" item-text="name" label="Associate Option" filled>
                            <template v-slot:item="{ active, item, attrs, on }">
                            <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                                <v-list-item-content>
                                <v-list-item-title>
                                    <v-row no-gutters align="center">
                                    <span>{{ item.name }}</span>
                                    <!-- <v-icon class="check-icon" v-if="question.b !== null && question.b !== '' && item.value === 'g'"
                                        color="green">fa
                                        fa-check
                                    </v-icon> -->
                                    <v-icon class="check-icon"
                                        v-if="question.b !== null && question.b !== '' && item.value === 'g' && associate_answer2[question.id] === item.name"
                                        color="green">fa fa-check</v-icon>
                                    <v-icon class="times-icon"
                                        v-else-if="question.b !== null && question.b !== '' && item.value != 'g' && associate_answer2[question.id] === item.name"
                                        color="red">fa fa-times</v-icon>
                                    </v-row>
                                </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            </template>
                        </v-select></div>
                        <div v-if="question.c">{{ question.c }} <v-select item-disabled="disable"
                            :items="multipleChoiceOptions.filter((e) => { return e.qid == question.id; })"
                            v-model="associate_answer3[question.id]" item-value="id" item-text="name" label="Associate Option" filled>
                            <template disabled v-slot:item="{ active, item, attrs, on }">
                            <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                                <v-list-item-content>
                                <v-list-item-title>
                                    <v-row no-gutters align="center">
                                    <span>{{ item.name }}</span>
                                    <!-- <v-icon class="check-icon" v-if="question.c !== null && question.c !== '' && item.value === 'h'"
                                        color="green">fa
                                        fa-check
                                    </v-icon> -->
                                    <v-icon class="check-icon"
                                        v-if="question.c !== null && question.c !== '' && item.value === 'h' && associate_answer3[question.id] === item.name"
                                        color="green">fa fa-check</v-icon>
                                    <v-icon class="times-icon"
                                        v-else-if="question.c !== null && question.c !== '' && item.value != 'h' && associate_answer3[question.id] === item.name"
                                        color="red">fa fa-times</v-icon>
                                    </v-row>
                                </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            </template>
                        </v-select></div>
                        <div v-if="question.d">{{ question.d }} <v-select item-disabled="disable"
                            :items="multipleChoiceOptions.filter((e) => { return e.qid == question.id; })"
                            v-model="associate_answer4[question.id]" item-value="id" item-text="name" label="Associate Option" filled>
                            <template v-slot:item="{ active, item, attrs, on }">
                            <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                                <v-list-item-content>
                                <v-list-item-title>
                                    <v-row no-gutters align="center">
                                    <span>{{ item.name }}</span>
                                    <!-- <v-icon class="check-icon" v-if="question.d !== null && question.d !== '' && item.value === 'i'"
                                        color="green">fa
                                        fa-check
                                    </v-icon> -->
                                    <v-icon class="check-icon"
                                        v-if="question.d !== null && question.d !== '' && item.value === 'i' && associate_answer4[question.id] === item.name"
                                        color="green">fa fa-check</v-icon>
                                    <v-icon class="times-icon"
                                        v-else-if="question.d !== null && question.d !== '' && item.value != 'i' && associate_answer4[question.id] === item.name"
                                        color="red">fa fa-times</v-icon>
                                    </v-row>
                                </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            </template>
                        </v-select></div>
                        <div v-if="question.e">{{ question.e }}<v-select item-disabled="disable"
                            :items="multipleChoiceOptions.filter((e) => { return e.qid == question.id; })"
                            v-model="associate_answer5[question.id]" item-value="id" item-text="name" label="Associate Option" filled>
                            <template v-slot:item="{ active, item, attrs, on }">
                            <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                                <v-list-item-content>
                                <v-list-item-title>
                                    <v-row no-gutters align="center">
                                    <span>{{ item.name }}</span>
                                    <!-- <v-icon class="check-icon" v-if="question.e !== null && question.e !== '' && item.value === 'j'"
                                        color="green">fa
                                        fa-check
                                    </v-icon> -->
                                    <v-icon class="check-icon"
                                        v-if="question.e !== null && question.e !== '' && item.value === 'j' && associate_answer5[question.id] === item.name"
                                        color="green">fa fa-check</v-icon>
                                    <v-icon class="times-icon"
                                        v-else-if="question.e !== null && question.e !== '' && item.value != 'j' && associate_answer5[question.id] === item.name"
                                        color="red">fa fa-times</v-icon>
                                    </v-row>
                                </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            </template>
                        </v-select></div>
                    </v-container>
        </v-stepper-content>
            </v-stepper-items>
        </v-stepper>
        <v-footer absolute height="68">
            <v-flex px-4 py-4 text-right action-button-div>
                <div>
                    <v-btn v-if="e1 > 1" color="dark-blue" class="ml-2 add-course-button" @click="back">Back</v-btn>
                    <v-btn v-else disabled color="dark-blue" class="ml-2 add-course-button" @click="back">Back</v-btn>
                </div>
                <div v-if="finished">
                    <span>
                        <v-btn color="dark-blue" class="ml-2 add-course-button" @click="closePanel">Finish</v-btn>
                    </span>
                </div>
                <div v-else>
                    <v-btn v-if="enableButton" color="dark-blue" class="ml-2 add-course-button" @click="next">Next</v-btn>
                    <v-btn v-else color="dark-blue" class="ml-2 add-course-button" @click="next">Next</v-btn>
                </div>
            </v-flex>
        </v-footer>
    </div>
    <div v-else><v-row>
            <v-col md="12" class="text-center ">
                <v-skeleton-loader type="article"></v-skeleton-loader>
            </v-col>
        </v-row> </div>
</template>
<script>

import testAPI from "@/api/test.js";
export default {
    name: "CourseTest",
    components: {},
    data() {
        return {
            loading: true,
            e1: 1,
            answers: {},
            finished: false,
            enableButton: false,
            multi_answers: {},
            list: ['f', 'g', 'h', 'i', 'j'],
            multipleChoiceOptions: [],
            associate_answer1: {},
            associate_answer2: {},
            associate_answer3: {},
            associate_answer4: {},
            associate_answer5: {},
            QuestionClass: 'd-flex text-xs-center'
        };
    },
    props: {
        id: {
            type: String,
            default: ''
        }
    },
    computed: {
        questions: function () {
            return this.$store.getters.test.questions;
        },
        quiz: function () {
            return this.$store.getters.test;
        }
    },
    mounted() {
        this.pickRandomOptions();
        this.getQuizLog(this.id);
    },
    watch: {
        e1: {
            handler() {
                if (this.e1 == this.questions.length) {
                    this.finished = true;
                }
            },
            deep: true
        }
    },
    methods: {
        getQuizLog(id) {
            testAPI.getQuizLog(id).then((response) => {
                response.data.data[0].answer_log.map((e) => {
                    if (e.question_type == 1 || e.question_type == 2) {
                        this.answers[e.id] = e.value;
                    }
                    if (e.question_type == 3) {
                        this.multi_answers = e.value
                    }
                    if (e.question_type == 4) {
                        this.associate_answer1[e.id] = e.value[1],
                            this.associate_answer2[e.id] = e.value[2],
                            this.associate_answer3[e.id] = e.value[3],
                            this.associate_answer4[e.id] = e.value[4],
                            this.associate_answer5[e.id] = e.value[5]
                    }
                });
                this.$store.getters.test.questions = response.data.data[0].questions
                this.loading = false
            });
        },
        closePanel() {
            this.$emit("closePanel");
        },
        next() {
            this.e1++;
        },
        back() {
            this.e1--;
            this.finished = false;
        },
        pickRandomOptions() {
            if (this.e1 == this.questions.length) {
                this.finished = true;
            }
            this.list.sort(() => Math.random() - 0.5);
            this.questions.forEach((value, index) => {
                if (value.question_type == 4) {
                    this.list.forEach((option, key) => {
                        if (option == "f" && value.f !== null && value.f !== '') {
                            this.multipleChoiceOptions.push(
                                {
                                    qid: value.id,
                                    name: value.f,
                                    value: 'f',
                                    disable: true
                                })
                        }
                        if (option == "g" && value.g !== null && value.g !== '') {
                            this.multipleChoiceOptions.push(
                                {
                                    qid: value.id,
                                    name: value.g,
                                    value: 'g',
                                    disable: true
                                })
                        }
                        if (option == "h" && value.h != null && value.h !== '') {
                            this.multipleChoiceOptions.push(
                                {
                                    qid: value.id,
                                    name: value.h,
                                    value: 'h',
                                    disable: true
                                })
                        }
                        if (option == "i" && value.i != null && value.i !== '') {
                            this.multipleChoiceOptions.push(
                                {
                                    qid: value.id,
                                    name: value.i,
                                    value: 'i',
                                    disable: true
                                })
                        }
                        if (option == "j" && value.j != null && value.j !== '') {
                            this.multipleChoiceOptions.push(
                                {
                                    qid: value.id,
                                    name: value.j,
                                    value: 'j',
                                    disable: true
                                })
                        }
                    });
                }
            });
        }
    }
};
</script>
<style scoped>
#popup-container .v-input__slot {
    border-bottom: 0px solid rgba(0, 0, 0, 0.6) !important;
}

.v-stepper__header {
    height: auto !important;
}</style>